import React, { useMemo } from 'react';

import { Typography } from '@vtblife/uikit';

import classname from '@search/classname/src';

import Slider from '@search/vtbeco-frontend-core/view/common/components/Slider';
// import CustomTypography from '@search/vtbeco-frontend-core/domain/newbuilding/components/common/CustomTypography';

import {
    ConstructionProgressItem,
    ConstructionProps,
    groupImages,
    Image,
    useConstructionGallery
} from '../../../../common/components/ConstructionProgress';

import './styles.css';

const cn = classname.bind(null, 'NewBuildingConstructionProgress');

const NewBuildingConstructionProgress = (props: ConstructionProps) => {
    const imageSuperGroups = useMemo<Image[][][]>(
        () => groupImages(props),
        [ props ]
    );

    const { handleGallery } = useConstructionGallery({
        title: `Ход строительства ${props.title.genitive}`
    });

    return (
        <div className={cn()}>
            {imageSuperGroups.map(imageGroups => (
                <div
                    className={cn('row')}
                    key={imageGroups[0][0].date}
                >
                    <Typography
                        variant='h2'
                        className={cn('sliderHeading')}
                    >
                        {imageGroups[0][0].date}
                    </Typography>
                    <div className={cn('sliderWrapper')}>
                        <Slider contentClassName={cn('slider')}>
                            {imageGroups.map((imageGroup, index) => (
                                <ConstructionProgressItem
                                    key={index}
                                    originPath={imageGroup[0].originPath}
                                    title={imageGroup[0].title}
                                    date={imageGroup[0].date}
                                    isDateHidden
                                    address={imageGroup[0].address}
                                    onImageClick={() => handleGallery(imageGroup, 0)}
                                    newBuildingName={props.title.nominative}
                                />
                            ))}
                        </Slider>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default React.memo(NewBuildingConstructionProgress);
